import { __extends } from "tslib";
import { ErrorBase } from './ErrorBase';
/**
 * PartialImplementationError is thrown when function was called that is not implemented yet.
 * it should never be used directly, but only by using Debug.throwPIR function
 */
var PartialImplementationError = /** @class */ (function (_super) {
    __extends(PartialImplementationError, _super);
    /**
     * Create a new AbstractMethodError.
     * @param message An optional message to override the default error message.
     * @param id The id of the error.
     */
    function PartialImplementationError(dependency, id) {
        if (dependency === void 0) { dependency = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, 'PartialImplementationError - this function is in development. Required Dependency: ' + dependency, id) || this;
    }
    return PartialImplementationError;
}(ErrorBase));
export { PartialImplementationError };
